import PostJob from "pages/static/Careers/PostJob";

function JobsPost() {
  return (
    <>
      <div>
        <PostJob />
      </div>
    </>
  );
}

export default JobsPost;
